/*
 * @Author: Jhonsem
 * @Date: 2018-10-25 20:33:06
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-06-20 17:03:18
 */

import { isJSON, isIos } from "@/utils/lodash";
import { sendErrorEventToWindow } from "@/utils/jsBridgeSendEvent";
import { versionGreaterThan, isSupportLocalFiles } from "@/utils/judgeVersion";

let bridge = window.WebViewJavascriptBridge;
let AppInfoCache: any = null;
export default class JsBridge {
  private baseConst = {
    Encrypt: "Encrypt", //GX 加密
    InsEncrypt: "InsEncrypt", //INS 加密
    HttpRequest: "HttpRequest", // HTTP 请求
    KillApp: "KillApp",
    GetWebViewUserAgent: "GetWebViewUserAgent",
    IapPurchase: "IapPurchase",
    IapSubscribe: "IapSubscribe", // IAP 订阅类型
    PaypalPurchase: "PaypalPurchase",
    PaypalGetMetaId: "PaypalGetMetaId",
    PaypalLaunchService: "PaypalLaunchService",
    StartNewWebInstance: "OpenAppInnerSafari", //创建和开启新的WebView
    BackPressed: "BackPressed", //监听安卓返回键
    DeviceInfo: "DeviceInfo", //设备信息
    GetIDFA: "GetIDFA",
    GetIDFV: "GetIDFV",
    DeviceId: "DeviceId", //获取设备Id
    AppInfo: "GetAppInfo",
    GetCookie: "GetCookies",
    ClearCookies: "ClearCookies",
    ClearAllCookies: "ClearAllCookies", //清除所有cookies
    IapPayPal: "IapPayPal", //IOS开启webview去加载网页的购买
    IapPayPalSubscribe: "IapPayPalSubscribe", //安卓单独的订阅
    IapCreditCard: "IapCreditCard", //IOS开启webview去加载网页的购买
    FbLogin: "FbLogin",
    LoadSetting: "LoadSetting", //加载setting配置
    SetSetting: "SetSetting", //存入setting配置
    ChangeMasterId: "ChangeMasterId", //告诉IOS自己的master_id
    ShowEmail: "ShowEmail", //原生调起邮箱
    DomReady: "DomReady", //告诉原生dom ready
    IapLocalizeUpdate: "IapLocalizeUpdate", //价格本地化
    OpenAlbum: "OpenAlbum",
    HandleNotification: "HandleNotification", //推送
    IsVideoAvailable: "IsVideoAvailable", //视频准备完毕
    PlayVideo: "PlayVideo", //播放视屏
    GuideUs: "GuideUs",
    ADConnect: "ADConnect",
    ADRecommend: "ADRecommend", //获取列表
    ADStart: "ADStart", //开始做任务
    SwitchFrontDesk: "SwitchFrontDesk", //后台切换到前台
    SwitchBackgroundDesk: "SwitchBackgroundDesk", //前台切换到后台
    AppLifecycleAndorid: "AppLifecycle",
    KeyboardHide: "KeyboardHide",
    GetPossibleCardType: "GetPossibleCardType", // 信用卡类型
    ValidateCreditCardNumber: "ValidateCreditCardNumber", // 信用卡有效性
    IapEvent: "IapEvent",
    GetStatusBarHeight: "GetStatusBarHeight",
    UmengLogWithParam: "UmengLogWithParam",
    UmengLog: "UmengLog", //友盟的
    LoadUserInfo: "LoadUserInfo", //混合app
    ShowNotification: "ShowNotification", //本地的通知
    CancelLocalNotification: "CancelLocalNotification", //cancel 本地的通知, just for iOS
    QuerySubscription: "QuerySubscription", // 判断当前google pay购买的自动订阅型的sku是否手动取消了
    ShowBatchNotification: "ShowBatchNotification", //批量注册消息
    TerminateData: "TerminateData", //ios存下需要发的通知，杀掉app的时候，原生会帮发
    CheckNotificationStatus: "CheckNotificationStatus", //检查用户是否打开了本地通知权限
    HandleNotificationStatus: "HandleNotificationStatus", //打开通知权限
    UpdateResourceStatus: "UpdateResourceStatus",
    ADSuperPay: "ADSuperPay", //backup
    PureSuperPayAppConfig: "PureSuperPayAppConfig", //纯super pay
    IapSuperPay: "IapSuperPay", //super_pay的支付
    IsSuperPayAvailable: "IsSuperPayAvailable", //用来判断是否有可用的superpayApp
    IapProductValid: "IapProductValid",
    V3PostOfferBlock: "V3PostOfferBlock",
    AlbumAuthorityEnabled: "AlbumAuthorityEnabled", // 相册权限
    CameraAuthorityEnabled: "CameraAuthorityEnabled", //相机权限
    CheckPhotoAuthority: "CheckPhotoAuthority", //检测用户是否同意了拍照或者相机权限，没有则弹框提醒
    Shake: "Shake", // 震动接口
    LaunchParam: "launchParam",
    GetLocalFiles: "GetLocalFiles",
    ChangeStatusbarStyle: "ChangeStatusBarStyle",
    SaveLocalFiles: "SaveLocalFiles"
  };

  /**
   * 初始化webview的监听
   */
  public initial() {
    // console.log('初始化jsbridge', new Date().getTime());
    if (isIos()) {
      // console.log('初始化IOS:');
      return new Promise((resolve, reject) => {
        try {
          const setupWebViewJavascriptBridge = (callback: any) => {
            if (window.hasOwnProperty("WebViewJavascriptBridge")) {
              return callback(window.WebViewJavascriptBridge);
            }
            if (window.hasOwnProperty("WVJBCallbacks")) {
              return window.WVJBCallbacks.push(callback);
            }
            window.WVJBCallbacks = [callback];
            const WVJBIframe = document.createElement("iframe");
            WVJBIframe.style.display = "none";
            WVJBIframe.src = "https://__bridge_loaded__";
            document.documentElement !== null &&
              document.documentElement.appendChild(WVJBIframe);
            setTimeout(() => {
              document.documentElement !== null &&
                document.documentElement.removeChild(WVJBIframe);
            }, 0);
          };
          setupWebViewJavascriptBridge((Bridge: any) => {
            bridge = Bridge;
            // console.log('ISO bridge初始化完毕：', Bridge);
            resolve();
          });
        } catch (error) {
          sendErrorEventToWindow("jsbridge_init_error_ios", error);
          reject(error);
        }
      });
    } else {
      //android:
      // console.log('初始化Android:');
      return new Promise((resolve, reject) => {
        try {
          if (window.WebViewJavascriptBridge) {
            //do your work here
            bridge = window.WebViewJavascriptBridge;
            // console.log('如果直接就有WebViewJavascriptBridge');
            resolve();
          } else {
            document.addEventListener(
              "WebViewJavascriptBridgeReady",
              () => {
                //do your work here
                // console.log('addEventListener WebViewJavascriptBridgeReady');
                bridge = window.WebViewJavascriptBridge;
                resolve();
              },
              false
            );
          }
        } catch (error) {
          sendErrorEventToWindow("jsbridge_init_error_android", error);
        }
      });
    }
  }
  /**
   * 发送事件并执行监听回调
   * @param handle
   * @param data
   */
  public call(handle: string, data: any = "") {
    console.info("[CALL DATA]:>>>>>", {
      handle,
      data
    });
    typeof data === "object"
      ? (data = JSON.stringify(data))
      : (data = data.toString());
    return new Promise((resolve, reject) => {
      bridge.callHandler(handle, data, (response: string) => {
        /**
         * 处理普通的jsbridge方法传过来的信息带msg和status字段，则返回msg;
         */
        console.info("[CALL Back DATA]:", {
          handle,
          data: response
        });
        try {
          const result = JSON.parse(response);
          if (result.status && result.status === "ok") {
            //只处理普通的jsbridge方法，网络方法需要通过拦截器进行详细的处理和解析
            result.hasOwnProperty("msg")
              ? resolve(
                  isJSON(result.msg) ? JSON.parse(result.msg) : result.msg
                )
              : resolve(result);
          } else {
            resolve(result);
          }
        } catch (error) {
          reject(error);
        }
      });
    });
  }
  /**
   * 监听Native发送来的回调
   * @param handle
   */
  public listen(handle: string) {
    return new Promise((resolve, reject) => {
      try {
        bridge.registerHandler(handle, (data: any, responseCallback: any) => {
          resolve({
            response: data,
            callBack: responseCallback
          });
        });
      } catch (error) {
        sendErrorEventToWindow("jsbridge_listen_error", error);
        reject(error);
      }
    });
  }
  /**
   * INS的加密
   * @param params
   */
  public insEncrypt(params: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const encryptData = await this.call(this.baseConst.InsEncrypt, params);
        resolve(encryptData);
      } catch (error) {
        sendErrorEventToWindow("ins_encrypt_error", error);
        reject(error);
      }
    });
  }
  /**
   * iap的打点
   */
  public IapEvent(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapEvent, params);
      resolve(response);
    });
  }
  /**
   * GX的加密
   * @param params
   */
  public gxEncrypt(params: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const encryptData = await this.call(this.baseConst.Encrypt, params);
        resolve(encryptData);
      } catch (error) {
        sendErrorEventToWindow("gx_encrypt_error", error);
        reject(error);
      }
    });
  }
  /**
   * Native的普通HTTP请求
   * @param params
   */
  public http(params: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.call(this.baseConst.HttpRequest, params);
        resolve(response);
      } catch (e) {
        console.log("http error: ", e);
        reject(e);
      }
    });
  }
  /**
   * Device Info
   */
  public DeviceInfo() {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.call(this.baseConst.DeviceInfo);
        resolve(response);
      } catch (error) {
        sendErrorEventToWindow("device_info_error", error);
        reject(error);
      }
    });
  }
  /**
   * GetIDFA
   */
  public GetIDFA() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.GetIDFA);
      resolve(response);
    });
  }
  /**
   * GetIDFV
   */
  public GetIDFV() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.GetIDFV);
      resolve(response);
    });
  }
  /**
   * 用户其他app注入userInfo
   */
  public LoadUserInfo() {
    return new Promise(async (resolve, reject) => {
      // if (isIos()) {
      //   resolve(true);
      //   return;
      // }
      // const response = await this.call(this.baseConst.LoadUserInfo);
      // resolve(response);
      resolve(true);
    });
  }
  public ADConnect() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ADConnect);
      console.log("ADConnect response", response);
      resolve(response);
    });
  }

  /**
   * 本地的通知
   * @param
   * {
   * title （必填）
   * content  （Android必填, ios选填）
   * imageUrl (带图通知的远程url，选填)
   *
   * timeInterval (数字，ios必填，毫秒为单位，意思是指多久以后启动本地通知)
   * badgeNumber（数字，选填）
   * repeatType  (选填，可选值：day, week, month, year,表示多久循环注册一次通知)
   * customData (选填，这里出现的参数都是以后会通过本地通知传回去给h5的参数)
   * }
   */
  public ShowNotification(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ShowNotification, params);
      resolve(response);
    });
  }
  /**
   * @param params
   * 批量注册消息,消息之间以&拼接成字符串，内容与上个方法一样
   */

  public ShowBatchNotification(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(
        this.baseConst.ShowBatchNotification,
        params
      );
      resolve(response);
    });
  }
  /**
   * @param params
   * 批量注册消息,杀掉app后，原生帮发消息
   */

  public TerminateData(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.TerminateData, params);
      resolve(response);
    });
  }

  /**
   * 取消本地通知 (iOS)
   * @param
   */
  public CancelLocalNotification() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.CancelLocalNotification);
      resolve(response);
    });
  }

  public ADRecommend() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ADRecommend);
      resolve(response);
    });
  }
  public ADStart(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ADStart, data);
      resolve(response);
    });
  }
  /**
   * APP INFO
   */
  public AppInfo() {
    return new Promise(async (resolve, reject) => {
      if (AppInfoCache) {
        resolve(AppInfoCache);
        return;
      }
      const response = await this.call(this.baseConst.AppInfo);
      resolve(response);
      AppInfoCache = response;
    });
  }
  /**
   * 退出APP
   */
  public KillApp() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.KillApp);
      resolve(response);
    });
  }
  /**
   * 获取URL下的cookie
   */
  public GetCookie(url: string) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.GetCookie, url);
      resolve(response);
    });
  }
  /**
   * 清除URL下的cookie
   * @param url
   */
  public ClearCookies(url: string) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ClearCookies, url);
      resolve(response);
    });
  }
  public ClearAllCookies() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ClearAllCookies);
      resolve(response);
    });
  }
  /**
   * rate us 5 star
   */
  public GuideUs() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.GuideUs);
      resolve(response);
    });
  }
  /**
   * 通过IAP支付
   * @param product_id
   */
  public IapPurchase(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapPurchase, params);
      resolve(response);
    });
  }
  /**
   * 通过IAP订阅
   * @param product_id
   */
  public IapSubscribe(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapSubscribe, data);
      resolve(response);
    });
  }
  /**
   * 通过PAY PAL支付
   * @param product_id
   */
  public PaypalPurchase(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.PaypalPurchase, data);
      resolve(response);
    });
  }
  /**
   * 通过辅助跳转到paypal的webview支付
   * @param data
   */
  public IapPayPal(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapPayPal, data);
      resolve(response);
    });
  }
  /**
   * paypal的订阅
   * @param data
   */
  public IapPayPalSubscribe(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapPayPalSubscribe, data);
      resolve(response);
    });
  }
  /**
   * 通过辅助跳转到credit的webview支付:
   * @param data
   */
  public IapCreditCard(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapCreditCard, data);
      resolve(response);
    });
  }
  /**
   * 初始化Pay Pal的service
   * @param key
   */
  public PaypalLaunchService(key: string) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.PaypalLaunchService, key);
      resolve(response);
    });
  }
  /**
   * 获取paypal的meta Id
   * @param key
   */
  public PaypalGetMetaId() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.PaypalGetMetaId);
      resolve(response);
    });
  }
  /**
   * 视频是否准备
   */
  public IsVideoAvailable(data: string) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IsVideoAvailable, data);
      resolve(response);
    });
  }
  /**
   * 播放视频
   * @params reward: 是否可加币， admob_enabled: 是否允许使用admob
   */
  public PlayVideo(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.PlayVideo, data);
      resolve(response);
    });
  }
  /**
   * Fb的Login
   */
  public FbLogin() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.FbLogin);
      resolve(response);
    });
  }
  /**
   * 加载配置setting
   */
  public LoadSetting() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.LoadSetting);
      resolve(response);
    });
  }
  /**
   * 加载配置setting
   */
  public ChangeMasterId(masterId: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ChangeMasterId, masterId);
      resolve(response);
    });
  }
  /**
   * 开启新的webview
   * @param masterId
   */
  public StartNewWebInstance(url: string) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.StartNewWebInstance, url);
      resolve(response);
    });
  }
  /**
   * 获取设备的ID用于匿名购买
   */
  public DeviceId() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.DeviceId);
      resolve(response);
    });
  }
  /**
   * 调起原生邮箱
   * @param data
   */
  public ShowEmail(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ShowEmail, data);
      resolve(response);
    });
  }
  //将配置信息存入原生的缓存：
  public SetSetting(data: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.call(this.baseConst.SetSetting, data);
        resolve(response);
      } catch (error) {
        sendErrorEventToWindow("set_setting_error", error);
        reject(error);
      }
    });
  }
  public DomReady() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.DomReady);
      resolve(response);
    });
  }
  public IapLocalizeUpdate() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapLocalizeUpdate);
      resolve(response);
    });
  }
  public GetStatusBarHeight() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.GetStatusBarHeight);
      resolve(response);
    });
  }
  /**
   * 校验信用卡的类型
   * @param data
   */
  public GetPossibleCardType(data: number) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(
        this.baseConst.GetPossibleCardType,
        data
      );
      resolve(response);
    });
  }
  public UmengLogWithParam(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.UmengLogWithParam, data);
      resolve(response);
    });
  }
  public UmengLog(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.UmengLog, data);
      resolve(response);
    });
  }
  /**
   * 校验信用卡的类型
   * @param data
   */
  public ValidateCreditCardNumber(data: number) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(
        this.baseConst.ValidateCreditCardNumber,
        data
      );
      resolve(response);
    });
  }
  public OpenAlbum(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.OpenAlbum, data);
      resolve(response);
    });
  }
  /**
   * 安卓的物理返回键
   * @param fn
   */
  public BackPressed(fn: any) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.BackPressed,
        (data: any, responseCallback: any) => {
          fn({
            response: data,
            callBack: responseCallback
          });
        }
      );
    });
  }

  public V3PostOfferBlock(fn: any) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.V3PostOfferBlock,
        (data: any, responseCallback: any) => {
          fn({
            response: data,
            callBack: responseCallback
          });
        }
      );
    });
  }
  /**
   * 推送
   * @param fn
   */
  public HandleNotification(fn: any) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.HandleNotification,
        (data: any, responseCallback: any) => {
          console.log(1231);
          console.log({
            response: data,
            callBack: responseCallback
          });
          fn({
            response: data,
            callBack: responseCallback
          });
        }
      );
    });
  }

  // /**
  //  * 监听是否点击了推送
  //  * @param fn
  //  */
  // public NotificationHold(fn: any) {
  //   return new Promise((resolve, reject) => {
  //     bridge.registerHandler(
  //       this.baseConst.NotificationHold,
  //       (data: any, responseCallback: any) => {
  //         fn({
  //           response: data,
  //           callBack: responseCallback
  //         });
  //       }
  //     );
  //   });
  // }

  /**
   * 切换到前台
   * @param fnArr
   */
  public SwitchFrontDesk(fnArr: any[]) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.SwitchFrontDesk,
        (data: any, responseCallback: any) => {
          console.log("收到了SwitchFrontDesk:", {
            fnArr,
            data
          });
          const newArr = [...fnArr];
          for (const item of newArr) {
            console.log("item key:", {
              key: item.key,
              newArr
            });
            item.fn();
          }
        }
      );
    });
  }

  /**
   * 切换到后台
   * @param fnArr
   */
  public SwitchBackgroundDesk(fnArr: any[]) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.SwitchBackgroundDesk,
        (data: any, responseCallback: any) => {
          console.log("收到了SwitchBackgroundDesk:", {
            fnArr,
            data
          });
          const newArr = [...fnArr];
          console.log(newArr);
          for (const item of newArr) {
            item.fn();
          }
        }
      );
    });
  }

  public AppGoForegroundAndroid(fnArr: any[]) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.AppLifecycleAndorid,
        (data: any, responseCallback: any) => {
          console.log("收到了AppGoForegroundAndroid:", {
            fnArr,
            data
          });
          const newArr = [...fnArr];
          for (const item of newArr) {
            item.fn();
          }
        }
      );
    });
  }

  public KeyboardHide(fnArr: any[]) {
    return new Promise((resolve, reject) => {
      bridge.registerHandler(
        this.baseConst.KeyboardHide,
        (data: any, responseCallback: any) => {
          console.log("KeyboardHide fnArr:", fnArr);
          for (const item of fnArr) {
            item.fn();
          }
        }
      );
    });
  }
  /**
   * 检查当前的sku是否被取消了
   * @param data
   */
  public QuerySubscription(data: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.QuerySubscription, data);
      resolve(response);
    });
  }
  /**
   * 检查用户是否打开了通知权限
   */
  public CheckNotificationStatus() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.CheckNotificationStatus);
      resolve(response);
    });
  }
  /**
   * 让用户打开通知权限
   */
  public HandleNotificationStatus() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.HandleNotificationStatus);
      resolve(response);
    });
  }
  /**
   * 查询当前APP是否安装过
   */
  public UpdateResourceStatus(packageName: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(
        this.baseConst.UpdateResourceStatus,
        packageName
      );
      resolve(response);
    });
  }
  /**
   * 获取superpay app的配置
   */
  public BackUpSuperPayAppConfig() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.ADSuperPay);
      resolve(response);
    });
  }

  /**
   * 获取backup app的配置
   */
  public PureSuperPayAppConfig() {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.call(this.baseConst.PureSuperPayAppConfig);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  public IapSuperPay(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IapSuperPay, params);
      resolve(response);
    });
  }
  /**
   * superpay app avalible
   */
  public IsSuperPayAvailable() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.IsSuperPayAvailable);
      resolve(response);
    });
  }

  public IapProductValid(productId: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(
        this.baseConst.IapProductValid,
        productId
      );
      resolve(response);
    });
  }

  public CameraAuthorityEnabled() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.CameraAuthorityEnabled);
      resolve(response);
    });
  }

  public AlbumAuthorityEnabled() {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.AlbumAuthorityEnabled);
      resolve(response);
    });
  }

  public CheckPhotoAuthority(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(
        this.baseConst.CheckPhotoAuthority,
        params
      );
      resolve(response);
    });
  }

  public Shake(params: any) {
    return new Promise(async (resolve, reject) => {
      const response = await this.call(this.baseConst.Shake, params);
      resolve(response);
    });
  }

  public LaunchParam() {
    return new Promise(async (resolve, reject) => {
      const vaild = versionGreaterThan("4.6.0");
      if (vaild) {
        const response = await this.call(this.baseConst.LaunchParam);
        resolve(response);
      } else {
        resolve(false);
      }
    });
  }

  /**
   * 改变 iOS status bar 内容的颜色，白色或者黑色
   * @param params 'white' or 'black'
   */
  public ChangeStatusbarStyle(params: any) {
    return new Promise(async (resolve, reject) => {
      if (!isIos()) {
        resolve(true);
        return;
      }
      const vaild = versionGreaterThan("4.6.0");
      if (vaild) {
        const response = await this.call(
          this.baseConst.ChangeStatusbarStyle,
          params
        );
        resolve(response);
      } else {
        resolve(true);
      }
    });
  }

  public GetLocalFiles() {
    return new Promise(async (resolve, reject) => {
      try {
        const valid = isSupportLocalFiles();
        if (valid) {
          const response = await this.call(this.baseConst.GetLocalFiles);
          resolve(response);
        } else {
          resolve(false);
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  public SaveLocalFiles(data: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const valid = isSupportLocalFiles();
        if (valid) {
          const response = await this.call(this.baseConst.SaveLocalFiles, data);
          resolve(response);
        } else {
          resolve(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  }
}
